import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FleetCoachAppReleasesActions from "../../store/actions/FleetCoachAppReleasesV2";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import ListPagination from "../../components/Common/ListPagination";
import AppReleasesList from "../../components/FleetCoachAppReleasesV2/AppReleasesList";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Button from "sushiweb/Button";
import Permission from "../../components/Common/Permission";
import FleetCoachAppReleasesModal from "../../components/FleetCoachAppReleasesV2/AppReleasesModal/index";

const FleetCoachAppReleasesV2 = (props) => {
  const {
    getFleetCoachAppReleasesList,
    setFleetCoachAppReleasesActiveFilters,
    appReleasesList,
    nextPage,
    prevPage,
    activeFilters,
  } = props;

  const [modalState, setModalState] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRelease, setActiveRelease] = useState({});
  const allActions = MenuActionsMappings[MenuNames.FLEET_COACH_APP_RELEASE_V2];

  const handlePagination = (action) => {
    let pageRequest = {};
    if (action === "prev") {
      pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
    } else {
      pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
    }
    getFleetCoachAppReleasesList(activeFilters, pageRequest);
  };

  const handleClick = (type, release_data) => {
    setModalState(type);
    setActiveRelease(release_data);
  };

  const handleModalClose = () => {
    setModalState(false);
  };

  const refreshList = () => {
    const pageRequest = {
      page: currentPage,
      page_size: 10,
    };
    getFleetCoachAppReleasesList([], pageRequest);
  };

  const getModal = () => {
    const addProps = {
      modalState: modalState,
      handleClose: handleModalClose,
      refreshList: refreshList,
    };

    const editProps = {
      ...addProps,
      activeRelease: activeRelease,
      refreshList: refreshList,
    };

    const launchProps = {
      ...editProps,
      refreshList: refreshList,
    };

    switch (modalState) {
      case "Edit":
        return <FleetCoachAppReleasesModal {...editProps} />;
      case "Add":
        return <FleetCoachAppReleasesModal {...addProps} />;
      case "Launch":
        return <FleetCoachAppReleasesModal {...launchProps} />;
      default:
        return;
    }
  };

  useEffect(() => {
    getFleetCoachAppReleasesList();
  }, []);

  return (
    <div className="container">
      <FlexContainer align="flex-start">
        <Heading>Fleet Coach App Releases</Heading>
        <div
          style={{ maxWidth: "320px" }}
          className="actionBar mb-20 flex items-center justify-end"
        >
          <Permission requiredPerms={[allActions.UPDATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn mr-16"
              data-testid="createNewAppRelease"
            >
              Create new release
            </Button>
          </Permission>
          {/* <FilterButton
                        activeFilters={activeFilters}
                        handleClick={handleFilterModalOpen}
                    /> */}
        </div>
      </FlexContainer>
      <AppReleasesList
        permissions={allActions}
        list={appReleasesList}
        handleRowClick={handleClick}
        activeAppRelease={activeRelease}
        setActiveAppRelease={setActiveRelease}
      />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handlePagination}
      />
      {modalState && getModal()}
    </div>
  );
};

function mapStateToProps(state) {
  const { FleetCoachAppReleases } = state;
  return {
    appReleasesList: FleetCoachAppReleases.appReleasesList,
    prevPage: FleetCoachAppReleases.prevPage,
    nextPage: FleetCoachAppReleases.nextPage,
    activeFilters: FleetCoachAppReleases.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFleetCoachAppReleasesList: bindActionCreators(
      FleetCoachAppReleasesActions.getFleetCoachAppReleasesList,
      dispatch
    ),
    setFleetCoachAppReleasesActiveFilters: bindActionCreators(
      FleetCoachAppReleasesActions.setFleetCoachAppReleasesActiveFilters,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FleetCoachAppReleasesV2);
